import { useSessionStore } from '../auth/session-store'
import { refreshTokenStore } from '../auth/token-store'
import { env } from '../config/env'
import { currentLocale } from '../i18n'
import { ApiClient } from './client'

export { ApiError } from './errors'
export { friendlyErrorKey, isUnauthorized } from './friendly-errors'
export { FormatError, parseList } from './parse'
export {
  normalizePrivateProfile,
  normalizeProfileSubset,
  normalizePublicProfile,
} from './profile'
export {
  parseActivityProjection,
  parseCategory,
  parseSavedActivity,
} from './records'
export type { ListItemParser } from './parse'
export type { RequestOptions, TokenPair } from './types'

/**
 * Shared API boundary. The generated client from P0-11 will wrap these
 * primitives; route loaders/actions should use this instance rather than
 * issuing ad-hoc fetches.
 */
export const api = new ApiClient({
  mode: env.authMode,
  baseUrl: env.apiBaseUrl,
  clientPlatform: env.clientPlatform,
  getAccessToken: () => useSessionStore.getState().accessToken,
  getRefreshToken: () => refreshTokenStore.get(),
  getLocale: () => currentLocale(),
  onTokensRefreshed: (tokens) =>
    useSessionStore.getState().applyTokens(tokens),
  onUnauthorized: () => useSessionStore.getState().clearSession(),
})
